var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-button',{staticClass:"toolItem",style:(_vm.alertStyle()),attrs:{"id":_vm.id,"type":"info","icon":_vm.icon,"size":"medium","title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }